import {
    FETCH_ECG_RECORDING_LIST,
    FETCH_MORE_ECG_RECORDING_LIST,
    FETCH_ECG_RECORDING_DETAILS,
    FETCH_ECG_RELATIVE_RECORDINGS,
    DELETE_ECG_RECORDING,
    FETCH_ECG_RECORDINGS_FOR_CALENDAR,
    FETCH_ECG_RECORDINGS_FOR_DAILY_SUMMARY,
    UPDATE_ECG_LIST_FILTERS,
    RESET_ECG_LIST_FILTERS,
    FETCH_ECG_VIDEO_TUTORIAL
} from './ActionTypes';

import { listOptions } from 'utils/ecg/ecgConstants';

export function fetchEcgRecordingList(payload, evictCache) {
    return {
        type: FETCH_ECG_RECORDING_LIST,
        payload,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export function fetchMoreEcgRecordingList(payload, evictCache) {
    return {
        type: FETCH_MORE_ECG_RECORDING_LIST,
        payload,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export function fetchEcgRecordingDetails(payload, evictCache) {
    return {
        type: FETCH_ECG_RECORDING_DETAILS,
        payload,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export function fetchEcgRelativeRecordings(payload, evictCache) {
    return {
        type: FETCH_ECG_RELATIVE_RECORDINGS,
        payload,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export function deleteEcgRecording(payload) {
    return {
        type: DELETE_ECG_RECORDING,
        payload
    };
}

export function fetchEcgRecordingsForCalendar(payload, evictCache) {
    return {
        type: FETCH_ECG_RECORDINGS_FOR_CALENDAR,
        payload,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export function fetchEcgRecordingsForDailySummary(payload, evictCache) {
    return {
        type: FETCH_ECG_RECORDINGS_FOR_DAILY_SUMMARY,
        payload,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export function updateEcgListFilters(payload) {
    return {
        type: UPDATE_ECG_LIST_FILTERS,
        payload,
        loadingType: listOptions.loadingTypes.reloadTable
    };
}

export function resetEcgListFilters() {
    return {
        type: RESET_ECG_LIST_FILTERS,
        loadingType: listOptions.loadingTypes.reloadTable
    };
}

export function fetchEcgVideoTutorial(payload, evictCache) {
    return {
        type: FETCH_ECG_VIDEO_TUTORIAL,
        payload,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}
